import React from "react";
import { useQuickSightLambda } from "@/hooks/useLambdaReports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsLambdaDashboard from "@/components/organisms/LambdaDashboard";

function LambdaReports() {
  const { embedUrl, loading, error, refetch } = useQuickSightLambda();

  return (
    <AWSReportsTemplate
      title="AWS Lambda Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsLambdaDashboard />
    </AWSReportsTemplate>
  );
}

export default LambdaReports;
